import { render, staticRenderFns } from "./DriverObject.vue?vue&type=template&id=62508437&lang=pug&"
import script from "./DriverObject.vue?vue&type=script&lang=ts&"
export * from "./DriverObject.vue?vue&type=script&lang=ts&"
import style0 from "./DriverObject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports